type Config = {
  API: string;
};

const env: {
  [key: string]: Config;
} = {
  local: {
    API: 'http://localhost:3000',
  },
  dev: {
    API: 'https://yxsfm0ni85.execute-api.eu-west-1.amazonaws.com/dev',
  },
  prod: {
    API: 'https://yk1xydgfu8.execute-api.us-east-1.amazonaws.com/prod',
  },
};

export default env[process.env.REACT_APP_STAGE || 'local'];
